<template>
  <div class="box-voice">
    <div class="voice-header m-b-10">
      <div>
        <v-icon>far fa-comment-dots</v-icon>
        <span class="m-l-5">Text-to-speech</span>
      </div>
      <div>
        <v-icon small :disabled="!prompt.text" @click="playPrompt">
          {{ isPlaying ? 'fa-stop-circle' : 'fa-play-circle' }}
        </v-icon>
        <v-icon small class="m-l-5" @click="deletePrompt">
          fa-times-circle
        </v-icon>
      </div>
    </div>

    <v-textarea
      v-model="prompt.text"
      label="Enter text"
      class="textarea-input no-drag"
      solo
      hide-details
      rows="2"
      row-height="20"
    ></v-textarea>

    <v-text-field
      v-if="isMetaverse"
      v-model="prompt.video"
      label="Video URL (optional)"
      class="m-t-20 m-b-10"
      hide-details
      dense
    ></v-text-field>

    <audio ref="myAudio" autoload>
      <source :src="previewVoice" type="audio/wav" />
      Your browser does not support the audio element.
    </audio>
  </div>
</template>

<script>
import _ from 'lodash'
import apiSynthesis from '@/apis/synthesis'

export default {
  name: 'PayloadTts',
  props: {
    items: Array,
    index: Number,
    prompt: Object,
    ttsProperty: Object,
    isMainPlaying: Boolean
  },
  data() {
    return {
      previewVoice: '',
      isPlaying: false,
      isMetaverse: process.env.VUE_APP_METAVERSE === 'true'
    }
  },
  watch: {
    isMainPlaying: {
      handler(val) {
        if (this.isMainPlaying) {
          this.$refs.myAudio.pause()
          this.isPlaying = false
        }
      }
    }
  },
  mounted() {
    this.$refs.myAudio.addEventListener('play', () => {
      this.isPlaying = true
    })
    this.$refs.myAudio.addEventListener('ended', () => {
      this.isPlaying = false
    })
  },
  methods: {
    async playPrompt() {
      try {
        if (!this.isPlaying) {
          const tts = await apiSynthesis.synthesis({
            ...this.ttsProperty,
            text: this.prompt.text,
            useCache: true
          })
          this.previewVoice = tts.data.audio

          this.$refs.myAudio.load()

          setTimeout(() => {
            this.$refs.myAudio.play()
          }, 300)
        } else {
          this.$refs.myAudio.pause()
          this.isPlaying = false
        }
      } catch {}
    },
    isSubPlaying() {
      this.$emit('isSubPlaying', null)
    },
    deletePrompt() {
      this.$emit('deletePrompt', this.index)
    }
  }
}
</script>

<style scoped lang="scss">
.box-voice {
  background-color: #f7f7f7;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ebebeb;
}

.voice-header {
  display: flex;
  justify-content: space-between;
}
</style>
